export default "__VITE_ASSET__5je_Ojti__"